module.exports = __webpack_public_path__ + "img/background_principal_pc380.f54ae9bd.webp";